import { render, staticRenderFns } from "./ANxAFxFamilyMembersPage.vue?vue&type=template&id=6756272c"
import script from "./ANxAFxFamilyMembersPage.vue?vue&type=script&lang=js"
export * from "./ANxAFxFamilyMembersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports